import {StoreSectionModel} from "../../models/storeSection";
import React from "react";
import {Body, Heading1, Heading3} from "../text";
import {Button} from "../buttons/Button";
import {StoreSectionCarouselType, StoreSectionCarouselView} from "./StoreSectionCarouselView";
import {ArrowNextExtendedIcon} from "../icons";
import {useTranslation} from "next-i18next";
import Skeleton from "react-loading-skeleton";
import {useAppDispatch} from "../../app/hooks";
import {push} from "connected-next-router";
import Link from "next/link";

export interface StoreSectionViewProps {
  storeSection: StoreSectionModel
  carouselType: StoreSectionCarouselType
  loading: boolean
}

export const StoreSectionView: React.FC<StoreSectionViewProps> = ({ storeSection, loading, carouselType }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  let { title, subtitle } = storeSection
  if (loading && !title) {
    title = "Default Title"
  }
  if (loading && !subtitle) {
    subtitle = "Default Title"
  }

  return (
    <div className="max-w-full mx-2 md:mx-4 lg:mx-6">
      <div className="flex flex-row items-stretch">
        <div className="flex-grow">
          <Heading1>{loading ? <Skeleton width="30%" /> : title}</Heading1>
          <Body className={`text-fg-gray-dark ${subtitle ? '' : 'hidden'}`}>{loading ? <Skeleton width="50%" /> : subtitle}</Body>
        </div>
        <div className="flex-shrink-0">
          {loading ? <Skeleton className="!h-8 !w-28 !rounded-full" /> : <Button
            buttonStyle="text_primary"
            className="text-right"
            trailingIconSizeClass="h-4 w-4"
            onClick={() => {
              dispatch(push(`/store-section/${storeSection.id}`))
            }}
            trailingicon={loading ? undefined : <ArrowNextExtendedIcon />}
          >
            {t('store:store_button_view_all')}
          </Button> }
        </div>
      </div>
      <StoreSectionCarouselView loading={loading} products={storeSection.products} carouselType={carouselType} />
    </div>
  )
}